import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';
import type {
  LogistikAdvertisingMaterialCategory,
  LogistikLearningMaterialCategory,
  LogistikProductCategory,
  LogistikProductTargetAudience,
  LogistikSchoolGrade,
} from './enums/LogistikEnums.js';

/**
 * @entity LogistikProductFilter
 */
@Entity()
export class LogistikProductFilter extends AdornisFilter {
  static override _class = 'LogistikProductFilter';

  @Field(() => [String], { default: v => v ?? null })
  targetAudiences: Maybe<LogistikProductTargetAudience[]>;

  @Field(() => String)
  category: Maybe<LogistikProductCategory | LogistikLearningMaterialCategory | LogistikAdvertisingMaterialCategory>;

  constructor(doc: PartialEntityData<LogistikProductFilter>) {
    super(doc);
  }

  @Field(() => String)
  grade: Maybe<LogistikSchoolGrade>;

  override getMongoFilter(): Record<string, any> {
    const filterArray = this.getFilterArray();
    if (!filterArray.length) return {};

    return { $and: [...this.getFilterArray()] };
  }

  getFilterArray(): Array<Record<string, any>> {
    const filter = this.toObject();

    return [
      ...(filter.targetAudiences ? [{ targetAudiences: { $in: filter.targetAudiences } }] : []),
      ...(filter.search ? [{ title: { $regex: filter.search.trim().replace(/(\W)/g, '\\$1'), $options: 'i' } }] : []),
      ...(filter.grade ? [{ grades: { $in: [filter.grade] } }] : []),
      ...(filter.category ? [{ $or: [{ category: filter.category }, { subCategory: filter.category }] }] : []),
    ];
  }
}
